module.exports = __webpack_public_path__ + "static/img/3@2x.40027b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/3@2x.png
// module id = fxQG
// module chunks = 1